function scrollToElement(id) {
  if (window.innerWidth > 750) {
    event.preventDefault();
    const element = document.getElementById(id);
    const stickyNav = document.querySelector(".alphabet-navigation");

    if (element) {
      const offset = stickyNav.clientHeight + 70;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }
}
